<template>
  <component :is="layout">
  	<div class="action-loading"  v-if="mainLoading">
      <div class="spinner-border text-black" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <router-view v-else-if="!errorCode"/>
    <component v-else :is="errorComponent"></component>
  </component>
</template>

<script>
  import { mapState } from 'vuex';
  import { fetchSessionUser } from '@/api/docs';
  export default {
    computed: {
      errorComponent() {
        return `error-${this.errorCode}`;
      },
      layout() {
        return `default-layout`;
      },
      ...mapState(['mainLoading', 'session', 'pageLayout', 'errorCode']),
    },
  };
</script>
